<template>
  <div id="forgot-password-selection">
    <div class="forgot-password-selection-container">
      <LeftView v-bind:coverImage="coverImage" />
      <div class="right-view">
        <onboarding-form

          class="forgot-password-form"
          v-bind:errorExists="errorExists"
          v-bind:formData="formData"
          v-on:changeInput="handleChange"
          v-bind:errors="errors"
          v-on:setErrorExists="setErrorExists"


          v-bind:formTitleText="formTitleText"
          v-bind:formSubtext="formSubtext"
          v-bind:formFields="formFields"
          v-bind:hintText="hintText"
          v-bind:baseLink="baseLink"
          v-bind:buttonText="buttonText"
          v-on:userData="userData"
          :toggle="toggle"
          v-on:toggleAnimation="lockChild"
        />
      </div>
    </div>
  </div>
</template>
<script>
import LeftView from '../components/SignupSelection/LeftView.vue';
import coverImage from '../assets/images/account-recovery-cover-image.jpg';
import OnboardingForm from '../components/body/OnboardingForm.vue';

export default {
  name: 'forgot-password',
  components: {
    LeftView,
    OnboardingForm,
  },
  data() {
    return {
      formData: {
        emailAddress: '',
      },
      errors: {
        emailError: ''
      },
      errorExists: '',
      toggle: false,
      formTitleText: 'Forgot Password',
      formSubtext: 'Enter your email address below to receive your password reset instructions.',
      formFields: [
        { name: 'emailAddress', placeholder: 'Email', type: 'email', errorName:'emailError' }
      ],
      baseLink: { link: '/login', text: 'Back to Login' },
      hintText: '',
      buttonText: 'Send',
      coverImage: coverImage,
    };
  },
  methods: {
    setErrorExists(value) {
      this.errorExists = value;
    },

    handleChange(data) {
      this.formData.emailAddress = data.value;
    },
    permitChild: function () {
      this.toggle = true;
    },
    lockChild: function () {
      this.toggle = false;
    },
    userData(data) {
      this.$store
          .dispatch('forgotPassword', data)
          .then((res) => {
            this.permitChild();
            if (res.response) {
              this.$toastr.success(res.response.message, 'Success');
              setTimeout(() => this.$router.push('/login'), 1000);
            } else {
              res.error.error
                ? this.$toastr.error(res.error.error, 'Failed')
                : this.$toastr.error(
                    'Couldn\'t establish connection',
                    res.error.message
                );
            }
          })
          .catch((error) => {
            throw error;
          });
    },
  },
};
</script>
<style scoped>
  .forgot-password-selection-container {
    display: flex;
  }
  @media only screen and (min-width: 991px) {
    .forgot-password-form {
      padding-top: 10%;
    }
  }
</style>
